<!-- =========================================================================================
    File Name: CardBasic.vue
    Description: Basic Cards
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="demo-basic-card">

    <vs-popup background-color="rgba(255,255,255,.6)" class=""  title="Message Board" :active.sync="messageBoardStatus">
       <vue-markdown :source="messageBoard"></vue-markdown>
    </vs-popup>
         
    <vs-popup class="qr-show" title="fullscreen" :active.sync="qr.show">
      <img class="w-full" :src="qr.data" />
    </vs-popup>
    <div class="vx-row" v-if="funds.length">
      <div class="vx-col w-full mb-base">
        <vx-card :title="`Funds Request`">
          <div class="vx-row">
            <div
              class="vx-col w-full sm:w-1/2 md:w-1/2 mb-base"
              v-for="fund in funds"
              :key="fund.id"
            >
              <vs-alert
                color="success"
                :title="`${fund.product.title} - ${fund.total} Tickets`"
                icon-pack="feather"
              >
                <div class="flex" style="gap:1ch;">
                  <div style="width:100px;">Product:</div>
                  <div style="width:100px;">{{ fund.product.title }}</div>
                </div>
                <div class="flex" style="gap:1ch;">
                  <div style="width:100px;">Submitted:</div>
                  <div style="width:100px;">
                    {{ formatDate(fund.createdAt) }}
                  </div>
                </div>
                <div class="flex" style="gap:1ch;">
                  <div style="width:100px;">Released:</div>
                  <div style="width:100px;">{{ fund.released }}</div>
                </div>
                <div class="flex" style="gap:1ch;">
                  <div style="width:100px;">Remainder:</div>
                  <div style="width:100px;">
                    {{ fund.total - fund.released }}
                  </div>
                </div>

                <vs-button
                  @click="release(fund)"
                  size="small"
                  class="mt-2"
                  color="#fff"
                  text-color="#000"
                  >Release Funds</vs-button
                >
              </vs-alert>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <div
      class="vx-row flex justify-center"
      v-if="$store.getters.isClient || $store.getters.isManageAll"
    >
      <vs-button class="my-base" to="/fund" color="danger"
        >$ Purchase Tickets</vs-button
      >
    </div>
    <div class="vx-row">
      <template v-for="crd in credits">
        <template v-if="crd.ticketsReleased - crd.ticketsUsed || crd.active">
          <div
            class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base"
            :key="crd.id"
          >
            <statistics-card-line
              icon="TargetIcon"
              :statistic="(crd.ticketsReleased - crd.ticketsUsed).commarize()"
              :statisticTitle="`${crd.title} Tickets`"
              :chartData="{}"
              type="area"
              custom="bare"
              class="relative stats-card"
            />
          </div>
        </template>
      </template>
    </div>

    <div class="vx-row" v-if="account && account.id && account.name">
      <div class="vx-col w-full md:w-1/2 mb-base centerx labelx">
        <vx-card :title="account.name">
          <!-- OTEHR DATA -->
          <div class="mt-5">
            <h6>Joined:</h6>
            <p>{{ formatDate(account.createdAt) }}</p>
          </div>

          <div class="mt-5">
            <h6>Address:</h6>
            <p>{{ account.address }}</p>
          </div>
          <div v-if="!$store.getters.isClient" class="mt-5">
            <h6>Company Email:</h6>
            <p>{{ companyEmail }}</p>
          </div>
          <div v-if="!$store.getters.isClient" class="mt-5">
            <h6>User Name:</h6>
            <p>{{ userName }}</p>
          </div>
          <div v-if="!$store.getters.isClient" class="mt-5">
            <h6>User Role:</h6>
            <p>{{ $store.state.user.role.name }}</p>
          </div>

          <div class="mt-5">
            <h6>Email:</h6>
            <p>{{ $store.state.user.email }}</p>
          </div>
        </vx-card>
      </div>

      <!-- ACTIVITY TIMELINE -->
      <div
        class="vx-col w-full sm:w-1/2 md:w-1/2 mb-base"
        v-if="outstandingPayments"
      >
        <vx-card title="Account Summary">
          <!-- USER BIO -->
          <div class="user-bio">
            <h3 class="text-danger">
              You have <b>${{ formatPrice(outstandingPayments) }}</b> in
              outstanding payments.
            </h3>
          </div>
        </vx-card>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-full lg:w-1/2 sm:w-1/2 mb-base">
        <vx-card title="Trucks">
          <!-- title="Gradient Background Color"
                    title-color="#fff"
                    content-color="#fff"
                    card-background="linear-gradient(to right, #56ab2f, #a8e063)" -->
          <vs-table :data="trucks" v-if="Object.keys(trucks).length">
            <template slot="thead">
              <vs-th>Lic Plate</vs-th>
              <vs-th>Truck Name</vs-th>
              <vs-th>QR Code</vs-th>
              <vs-th>Status</vs-th>
              <vs-th></vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="tr.licPlate">
                  {{ tr.licPlate }}
                </vs-td>

                <vs-td :data="tr.name">
                  {{ tr.name }}
                  <template slot="edit">
                    <div class="py-3 flex">
                      <vs-input v-model="tr.name" />
                      <vs-button
                        @click.native="update('trucks', tr)"
                        radius
                        color="primary"
                        type="filled"
                        icon-pack="feather"
                        icon="icon-check"
                      ></vs-button>
                    </div>
                  </template>
                </vs-td>

                <vs-td :data="tr">
                  <a @click.prevent="qrClick(tr)" href="#">PDF</a>
                </vs-td>

                <vs-td :data="tr.status">
                  <div class="flex items-center justify-start w-full truckStyle">
                    <label :for="'activeToggle'+tr.id" class="flex items-center cursor-pointer">
                      <div class="relative">
                        <input :id="'activeToggle'+tr.id" type="checkbox" class="sr-only" v-model="tr.status" @change="trStatus(tr)"/>
                        <div class="w-10 h-6 bg-gray-400 rounded-full shadow-inner" style="background: #b5b5b5;"></div>
                        <div class="dot absolute w-6 h-6 bg-white rounded-full shadow -left-1 -top-1 transition"></div>
                      </div>
                      <!-- label -->
                      <div class="ml-3 text-gray-700 font-medium">{{tr.status ? 'Active': 'Inactive'}}</div>
                    </label>
                  </div>
                </vs-td>

                <vs-td :data="tr.id">
                  <!-- <a @click.prevent="qrClick(tr)" href="#">Edit</a> -->
                  <vs-button
                    @click.native="deleteItem('trucks', tr)"
                    radius
                    color="danger"
                    type="filled"
                    icon-pack="feather"
                    size="small"
                    icon="icon-trash"
                  ></vs-button>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <p v-else>
            No Trucks found
          </p>
          <template slot="footer">
            <vs-divider />
            <div class="flex justify-between">
              <span class="flex items-center">
                <feather-icon
                  icon="TruckIcon"
                  svgClasses="h-5 w-5 text-primary stroke-current"
                />
                <span class="ml-2">{{ trucks.length }} Truck(s)</span>
              </span>
              <div class="flex items-center">
                <vs-button
                  radius
                  @click.native="addTruck = true"
                  color="primary"
                  type="filled"
                  icon-pack="feather"
                  icon="icon-plus"
                ></vs-button>
              </div>
            </div>
          </template>
        </vx-card>
      </div>
      <div class="vx-col w-full lg:w-1/2 sm:w-1/2 mb-base">
        <vx-card title="Drivers">
          <vs-table :data="drivers" v-if="Object.keys(drivers).length">
            <template slot="thead">
              <vs-th>Firstname</vs-th>
              <vs-th>Lastname</vs-th>
              <vs-th>Status</vs-th>
              <vs-th></vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="tr">
                  {{ tr.firstName }}
                  <template slot="edit">
                    <div class="py-3 flex">
                      <vs-input v-model="tr.firstName" />
                      <vs-button
                        @click.native="update('drivers', tr)"
                        radius
                        color="primary"
                        type="filled"
                        icon-pack="feather"
                        icon="icon-check"
                      ></vs-button>
                    </div>
                  </template>
                </vs-td>

                <vs-td :data="tr">
                  {{ tr.lastName }}
                  <template slot="edit">
                    <div class="py-3 flex">
                      <vs-input v-model="tr.lastName" />
                      <vs-button
                        @click.native="update('drivers', tr)"
                        radius
                        color="primary"
                        type="filled"
                        icon-pack="feather"
                        icon="icon-check"
                      ></vs-button>
                    </div>
                  </template>
                </vs-td>

                <vs-td :data="tr">
                  <div class="flex items-center justify-start w-full truckStyle">
                    <label :for="'activeToggle'+tr.id" class="flex items-center cursor-pointer">
                      <div class="relative">
                        <input :id="'activeToggle'+tr.id" type="checkbox" class="sr-only" v-model="tr.status" @change="drStatus(tr)"/>
                        <div class="w-10 h-6 bg-gray-400 rounded-full shadow-inner" style="background: #b5b5b5;"></div>
                        <div class="dot absolute w-6 h-6 bg-white rounded-full shadow -left-1 -top-1 transition"></div>
                      </div>
                      <!-- label -->
                      <div class="ml-3 text-gray-700 font-medium">{{tr.status ? 'Active': 'Inactive'}}</div>
                    </label>
                  </div>
                </vs-td>

                <vs-td>
                  <vs-button
                    @click.native="deleteItem('drivers', tr)"
                    radius
                    color="danger"
                    type="filled"
                    icon-pack="feather"
                    size="small"
                    icon="icon-trash"
                  ></vs-button>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <p v-else>
            No Drivers found
          </p>
          <template slot="footer">
            <vs-divider />
            <div class="flex justify-between">
              <span class="flex items-center">
                <feather-icon
                  icon="UserIcon"
                  svgClasses="h-5 w-5 text-primary stroke-current"
                />
                <span class="ml-2">{{ drivers.length }} Driver(s)</span>
              </span>
              <div class="flex items-center">
                <vs-button
                  radius
                  @click.native="addDriver = true"
                  color="primary"
                  type="filled"
                  icon-pack="feather"
                  icon="icon-plus"
                ></vs-button>
              </div>
            </div>
          </template>
        </vx-card>
      </div>
    </div>
    <div
      class="vx-row"
      id="activity"
      v-if="
        activities.length &&
          ($store.getters.isClient || $store.getters.isManageAll)
      "
    >
      <div class="vx-col w-full lg:w-1/2 sm:w-1/2 mb-base">
        <vx-card title="Transaction Timeline">
          <ul class="activity-timeline">
            <template v-for="item in activities">
              <li :key="item.id">
                <div
                  class="timeline-icon"
                  :class="`bg-${activityLookup[item.what].color}`"
                >
                  <feather-icon
                    :icon="activityLookup[item.what].icon"
                    svgClasses="text-white stroke-current w-5 h-5"
                  ></feather-icon>
                </div>

                <div class="timeline-info" v-if="item.what === 'used'">
                  <p class="font-semibold">{{ item.product.title }} Ticket</p>
                  <span class="activity-desc">Used</span>
                </div>
                <div class="timeline-info" v-else-if="item.what === 'paid'">
                  <p class="font-semibold">
                    {{ formatPrice(item.amount) }} Paid
                  </p>
                  <span class="activity-desc"
                    >Invoice #{{ item.ticketOrder.uid }}</span
                  >
                </div>
                <div class="timeline-info" v-else>
                  <p class="font-semibold" v-if="item.orderItems.length === 1">
                    {{ item.orderItems[0].product.title }} ({{
                      item.orderItems[0].quantity
                    }}
                    Tickets)
                  </p>
                  <p class="font-semibold" v-else>
                    {{ item.orderItems.length }} Products ({{
                      getTicketCount(item.orderItems)
                    }}
                    Tickets total)
                  </p>
                  <span class="activity-desc"
                    >Purchased (Invoice# {{ item.uid }})</span
                  >
                </div>
                <small class="text-grey activity-e-time">{{
                  formatDate(item.createdAt)
                }}</small>
              </li>
            </template>
          </ul>
          <vs-button color="warning" to="/my-transactions"
            >View All Transactions</vs-button
          >
        </vx-card>
      </div>
    </div>

    <vs-prompt
      @cancel="clearValMultiple"
      @accept="addItem('trucks')"
      title="Add Truck"
      :is-valid="validName"
      :active.sync="addTruck"
    >
      <div class="con-exemple-prompt">
        Enter the Truck's Information below and click Accept to <b>continue</b>.
        <vs-input
          placeholder="Name"
          v-model="truck.name"
          class="mt-4 mb-2 w-full"
        />
        <vs-input
          placeholder="License Plate"
          v-model="truck.licPlate"
          class="w-full"
        />

        <vs-alert v-show="!validName" color="danger" vs-icon="new_releases">
          Fields can not be empty please enter the data
        </vs-alert>
      </div>
    </vs-prompt>
    <vs-prompt
      @cancel="clearValMultiple"
      @accept="addItem('drivers')"
      :is-valid="validDriver"
      title="Add Driver"
      :active.sync="addDriver"
    >
      <div class="con-exemple-prompt">
        Enter the Driver's Information below and click Accept to
        <b>continue</b>.
        <vs-input
          placeholder="Firstname"
          v-model="driver.firstName"
          class="mb-2 mt-4 w-full"
        />
        <vs-input
          placeholder="Lastname"
          v-model="driver.lastName"
          class="mt-4 w-full"
        />

        <vs-alert
          v-show="!validDriver"
          color="danger"
          vs-icon="new_releases"
          class="mt-2"
        >
          Fields can not be empty please enter the data
        </vs-alert>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import SaveButton from "@/components/SaveButton";
import { videoPlayer } from "vue-video-player";
import {
  arrToObj,
  formatDate,
  setProp,
  deleteProp,
  $loading,
  $load,
  formatPrice
} from "@/assets/helper";
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
import "video.js/dist/video-js.css";

import VueMarkdown from 'vue-markdown'

export default {
  components: {
    StatisticsCardLine,
    VueMarkdown 
  },
  watch: {
    account(val) {},
    addTruck() {
      this.truck = {
        name: "",
        licPlate: ""
      };
    }
  },
  data() {
    return {
      activities: [],
      qr: {
        show: false,
        data: ""
      },
      fund: {
        max: 10000,
        amount: 0,
        show: false,
        id: ""
      },

      addDriver: false,
      addTruck: false,
      val: "",
      driver: {
        firstName: "",
        lastName: "",
        lic: ""
      },
      truck: {
        name: "",
        licPlate: ""
      },
      funds: [],
      credits: {},
      relations: {},
      preferences: {},

      name: "",
      email: "",
      msg: "",
      options: {},
      productObj: {},
      playerOptions: {
        height: "460",
        fluid: true,
        autoplay: false,
        muted: true,
        language: "en",
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          { type: "video/mp4", src: "http://vjs.zencdn.net/v/oceans.mp4" }
        ],
        poster: "https://goo.gl/xcCsDd"
      },
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      },
      chatMsgInput: "",
      chatMsg: [
        {
          senderImg: "avatar-s-2.png",
          msg: "Cake sesame snaps cupcake gingerbread",
          isSent: false
        },
        {
          senderImg: "avatar-s-5.png",
          msg: "Apple pie pie jujubes chupa chups muffin",
          isSent: true
        },
        { senderImg: "avatar-s-2.png", msg: "Chocolate cake", isSent: false },
        {
          senderImg: "avatar-s-5.png",
          msg: "Donut sweet pie oat cake dragée fruitcake",
          isSent: true
        },
        {
          senderImg: "avatar-s-2.png",
          msg: "Liquorice chocolate bar jelly beans icing",
          isSent: false
        },
        { senderImg: "avatar-s-5.png", msg: "Pudding candy", isSent: true }
      ],
      account: {},
      user: {},
      trucks: [],
      drivers: [],
      companyEmail: "",
      origAccount: {},
      activityLookup: {
        used: {
          color: "primary",
          icon: "TruckIcon"
        },
        ordered: {
          color: "danger",
          icon: "ShoppingCartIcon"
        },
        paid: {
          color: "warning",
          icon: "DollarSignIcon"
        }
      },

      parentId: "",
      messageBoard: "",
      messageBoardStatus: false,
   

    };
  },
  computed: {
    outstandingPayments() {
      return 0;
    },
    truckLic() {
      let { licPlate } = this.truck;
      return licPlate.replace(/ /g, "").toUpperCase();
    },
    products() {
      return this.$store.state.products;
    },
    validName() {
      return this.truck.name.length > 0 && this.truck.licPlate.length > 0;
    },
    validDriver() {
      return (
        this.driver.firstName.length > 0 && this.driver.lastName.length > 0
      );
    }
  },
  methods: {
    formatDate,
    formatPrice,
    getTicketCount(orderItems) {
      let count = 0;
      orderItems.forEach(({ quantity }) => {
        count += quantity;
      });
      return count;
    },
    async refreshCredits() {
      $load(".stats-card > div ");
      if (this.$store.getters.isManageAll || this.$store.getters.isManageTruckDriverOnly) {
        let { data } = await this.$get(`/accounts/${this.parentId}/tickets`);
        console.log(data);
        this.credits = data;
      } else if (this.$store.getters.isClient) {
        let { data } = await this.$get(`/accounts/me/tickets`);
        this.credits = data;
      }

      console.log(this.credits, "credits");
      $load(".stats-card > div ", false);
    },
    async addItem(where) {
      let item = false;
      let itemLabel = "";
      if (where === "trucks") {
        itemLabel = "Truck";
        item = {
          name: this.truck.name,
          licPlate: this.truckLic,
          qr: Date.now() + this.account.id,
          accid: this.account.id,
          account: this.account.id
        };
        let { data: dup } = await this.$api.get(
          "/trucks?licPlate=" + this.truckLic
        );
        console.log('datadatadatadata')
        console.log(dup,'datadatadatadata')
        console.log('datadatadatadata')

        if (dup && dup.length) {
          return this.$vs.notify({
            color: "danger",
            title: "License Plate has to be unique.",
            text:
              "This License Plate already exists in the system. Please try again."
          });
        }
      } else if (where === "drivers") {
        itemLabel = "Driver";
        item = {
          ...this.driver,
          account: this.account.id
        };
      }

      if (!item) return console.error("ERROR HAPPENED");

      this.$api
        .post(`/${where}`, item)
        .then(({ data }) => {
          setProp(this.$data, [where, data.id], data);
          this.$vs.notify({
            color: "success",
            title: itemLabel + " Created"
          });
        })
        .catch(err => {
          console.error("ERROR", err);
        });
    },
    clearValMultiple() {
      this.truck = {
        name: "",
        licPlate: ""
      };
      this.driver = {
        firstName: "",
        lastName: "",
        lic: ""
      };
    },
    deleteItem(where, what) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm Deletion`,
        text:
          "You are about to permanently delete an item  (The history will be lost). Please confirm that this is the action you want to perform.",
        accept: () => this.acceptDelete(where, what)
      });
    },
    async acceptDelete(where, what) {
      this.$api
        .delete(`/${where}/${what.id}`)
        .then(({ data }) => {
          this.$vs.notify({
            color: "danger",
            title: "Deleted!",
            text: `The selected item was successfully deleted`
          });
          // let idx = this.$data[where].findIndex(x => x.id === what.id)
          deleteProp(this.$data, [where, what.id]);
        })
        .catch(err => {
          console.error("ERROR", err);
        });
    },
    async update(where, what) {
      console.log("UPDATING", where);
      console.log("on ", what);
      this.$api
        .put(`/${where}/${what.id}`, what)
        .then(({ data }) => {
          console.log(data)
          this.$vs.notify({
            title: "Success",
            text: "Updated Successfully",
            color: "success",
            iconPack: "feather",
            icon: "icon-check",
            position: "bottom-center"
          });
          document.body.click();
        })
        .catch(err => {
          console.error("ERROR", err);
        });
    },
    async qrClick(tr) {
      window.open(`${process.env.VUE_APP_API}/v1/qr/` + tr.id);
    },
    async getMessageBoard() {
      let { data } = await this.$api.get(`/message-boards`);
      this.messageBoard = data[0].message;
      this.messageBoardStatus = data[0].status
    },
    async trStatus(tr){
      await this.update('trucks', tr)
    },
    async drStatus(tr){
      await this.update('drivers', tr)
    }
  },
  async created() {
    let { data } = await this.$api.get("/accounts/me");
    console.log(data);
    console.log(data.parentId);
    this.parentId = data.parentId;
    if (this.parentId) {
      let params = { pId: this.parentId, roleId: data.user.role.id };
      this.userName = data.name;
      let { data: parentData } = await this.$api.get(`/accounts/parent`, {
        params
      });
      console.log(parentData, "parent data");
      var {
        user,
        trucks = [],
        drivers = [],
        credits = [],
        overDraftLimit = 0,
        quickReleaseLimit = 0,
        lowFundThreshold = 1,
        funds = [],
        options,
        ...account
      } = parentData;
    } else {
      var {
        user,
        trucks = [],
        drivers = [],
        credits = [],
        overDraftLimit = 0,
        quickReleaseLimit = 0,
        lowFundThreshold = 1,
        funds = [],
        options,
        ...account
      } = data;
    }

    // console.log(user, "user");
    // console.log(account, "account");
    let relations = {};
    relations.user = user.id;
    relations.trucks = trucks.map(x => x.id);
    relations.drivers = drivers.map(x => x.id);

    this.relations = relations;
    this.funds = funds
      .filter(x => x.status !== "complete" && this.products[x.product])
      .map(x => ({
        ...x,
        released: x.released ? x.released : 0,
        product: this.products[x.product]
      }));
    this.preferences = { overDraftLimit, quickReleaseLimit, lowFundThreshold };

    let accountCredits = {};
    credits.forEach(({ product, amount = 0 }) => {
      if (!this.products[product]) return;
      if (!accountCredits[product])
        accountCredits[product] = {
          product: this.products[product],
          amount: 0
        };
      accountCredits[product].amount += amount;
    });

    if (!account.name) account.name = "Unnamed";

    if (!options) options = {};
    if (!options.overDraft) options.overDraft = {};
    if (!options.quickRelease) options.quickRelease = {};
    if (!options.minNotification) options.minNotification = {};

    let { data: prds } = await this.$api.get("/products");
    let productObj = {};

    prds.forEach(prd => {
      if (!options.overDraft.hasOwnProperty(prd.id))
        options.overDraft[prd.id] = 0;
      if (!options.quickRelease.hasOwnProperty(prd.id))
        options.quickRelease[prd.id] = 0;
      if (!options.minNotification.hasOwnProperty(prd.id))
        options.minNotification[prd.id] = 0;
      productObj[prd.id] = prd;
    });

    this.options = options;
    this.productObj = productObj;

    this.account = account;
    console.log(this.account);
    this.trucks = arrToObj(trucks);
    console.log(this.trucks,'this.trucksthis.trucks')
    this.drivers = arrToObj(drivers);

    this.user = user;
    this.companyEmail = user.email;

    this.refreshCredits();

    let { data: ordered } = await this.$get(
      `/accounts/get?where=ordered&_sort=updatedAt:DESC&_limit=5`
    );
    let { data: used } = await this.$get(
      `/accounts/get?where=used&_sort=updatedAt:DESC&_limit=5`
    );
    let { data: paid } = await this.$get(
      `/accounts/get?where=paid&_sort=updatedAt:DESC&_limit=5`
    );
    ordered = ordered.map(x => ({ ...x, what: "ordered" }));
    used = used.map(x => ({ ...x, what: "used" }));
    paid = paid.map(x => ({ ...x, what: "paid" }));

    let activities = [...ordered, ...used, ...paid];

    activities = activities.sort(({ createdAt: a }, { createdAt: b }) => {
      if (a > b) return -1;
      return 1;
    });
    this.activities = activities;
    this.getMessageBoard();
  },
  mounted() {
    if (this.$refs.chatLogPS) {
      this.$refs.chatLogPS.$el.scrollTop = this.$refs.chatLog.scrollHeight;
    }
  }
};
</script>

<style lang="scss">
#demo-basic-card {
  .overlay-card {
    .vx-card__collapsible-content {
      max-height: 485px;
    }
  }

  .chat-card-log {
    height: 360px;

    .chat-sent-msg {
      background-color: #f2f4f7 !important;
    }
  }

  .card-video {
    .video-js {
      height: 370px;
    }
  }
}
.qr-show {
}


/* Toggle */
.truckStyle .dot {
  top: 0;
  right: 50%;
}
.truckStyle input:checked ~ .dot {
  transform: translateX(100%) !important;
  background-color: #598d7f !important;
}


</style>
